<template>
  <div class="candidate-modal-changes-history">
    <scrolled-table v-if="!loadingCandidateInfo && candidateInfo && candidateInfo.history">
      <table class="h-table">
        <thead>
          <tr>
            <th>Изменено</th>
            <th>История кандидата</th>
            <th>Комментарий</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, recordIndex) in candidateInfo.history" :key="recordIndex">
            <td>
              <div class="candidate-modal-changes-history__date-cell">{{ record.time }}</div>
            </td>
            <td>{{ record.description }}</td>
            <td>{{ record.comment ? record.comment : "—" }}</td>
          </tr>
        </tbody>
      </table>
    </scrolled-table>

    <c-loader v-if="loadingCandidateInfo" :active="true" height="300" label="Загрузка данных" />
  </div>
</template>

<script>
import ScrolledTable from "@/components/scrolled-table";
import Loader from "@/components/loader";

export default {
  name: "candidate-modal-changes-history",
  components: {
    ScrolledTable,
    "c-loader": Loader,
  },
  props: {
    candidateInfo: {
      type: Object,
      default: () => ({}),
    },
    loadingCandidateInfo: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.candidate-modal-changes-history {
  overflow-y: auto;
  height: 70vh;

  &::-webkit-scrollbar {
    width: 4px;
    height: 100%;
  }

  &::-webkit-scrollbar-thumb {
    background: $color-secondary;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background: $color-border-alt;
  }

  &__date-cell {
    white-space: nowrap;
  }
}
</style>
